import { ip_back } from "../config";

/** OVH Object Storage does not send Access-Control-Allow-Origin. */
export function isOvhObjectStorageUrl(value) {
  if (value == null || typeof value !== "string") return false;
  try {
    const host = new URL(value.trim()).hostname.toLowerCase();
    return host === "s3.gra.io.cloud.ovh.net" || host.endsWith(".s3.gra.io.cloud.ovh.net");
  } catch {
    return false;
  }
}

/**
 * Legacy default from API / DEFAULT_BRAND — must not be prefixed with `ip_back`
 * (file is not on the API host; use bundled app logo instead).
 */
export function isSmartttPlaceholderLogoUrl(value) {
  if (value == null || typeof value !== "string") return false;
  const t = value.trim().toLowerCase().split("?")[0];
  if (!t) return false;
  return t === "/smarttt-logo.png" || t === "smarttt-logo.png" || t.endsWith("/smarttt-logo.png");
}

/**
 * Absolute URL for a club/brand image served from the API, or null if missing / placeholder.
 */
export function resolveClubImageUrl(value) {
  if (value == null || typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (isSmartttPlaceholderLogoUrl(trimmed)) return null;
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith("data:") || trimmed.startsWith("blob:")) return trimmed;
  if (trimmed.startsWith("/")) return `${ip_back.replace(/\/$/, "")}${trimmed}`;
  return `${ip_back}${trimmed}`;
}

/**
 * Club/brand logo for UI: club image first, then brand main logo, then favicon.
 * Do not use this in DigiPing chat headers — favicon is the platform shield
 * and shows a broken icon on first-time signup before a club exists.
 */
export function resolveClubLogoUrl(clubImage, brand = null) {
  const candidates = [clubImage, brand?.logo_url, brand?.favicon_url];
  for (const raw of candidates) {
    const resolved = resolveClubImageUrl(raw);
    if (resolved) return resolved;
  }
  return null;
}

/**
 * URL safe to assign to a favicon or canvas image.
 * Raw OVH URLs are fetched by the browser in CORS mode and fail closed.
 */
export function corsSafeLogoUrl(value) {
  const resolved = resolveClubImageUrl(value);
  if (!resolved || !isOvhObjectStorageUrl(resolved)) return resolved;
  const base = String(ip_back || "/").replace(/\/?$/, "/");
  return `${base}api/brand/logo-proxy?url=${encodeURIComponent(resolved)}`;
}

/** Strip placeholder logo from persisted brand objects so theme logic stays correct. */
export function sanitizeBrandLogoUrl(brand) {
  if (!brand || typeof brand !== "object") return brand;
  if (!isSmartttPlaceholderLogoUrl(brand.logo_url)) return brand;
  return { ...brand, logo_url: null };
}
